import {createAction, createRequestActions} from 'common/helpers/actionHelpers';

export const ready = createAction('APP.READY');
export const online = createAction('APP.ONLINE');
export const uuid = createAction('APP.UUID');
export const moment = createAction('APP.MOMENT');
export const calcIntervals = createAction('APP.CALC_INTERVALS');
export const loadSettings = createRequestActions('APP.LOAD_SETTINGS');

export const book = createRequestActions('BOOK.SEND_FORM');
export const loadBookings = createRequestActions('BOOK.LOAD_BOOKINGS');
export const loadMyBookings = createRequestActions('BOOK.LOAD_MY_BOOKINGS');
export const loadTables = createRequestActions('BOOK.LOAD_TABLES');
export const selectIntervals = createAction('BOOK.SELECT_INTERVALS');
export const unselectIntervals = createAction('BOOK.UNSELECT_INTERVALS');
export const unselectAll = createAction('BOOK.UNSELECT_ALL');
export const cancelMyBooking = createRequestActions('BOOK.CANCEL_MY_BOOKING');
export const swipeIsShown = createAction('BOOK.SWIPE');

export const sendReview = createRequestActions('REVIEW.SEND_FORM');

export const findCard = createRequestActions('CARD.FIND');
export const createCard = createRequestActions('CARD.CREATE');
export const clearCardInfo = createAction('CARD.CLEAR_INFO');

export const socketServerOn = createAction('SOCKET.SERVER_ON');
export const socketServerOff = createAction('SOCKET.SERVER_OFF');



// WEBPACK FOOTER //
// ./src/actions/index.js